import store from '@/vuex/store'
import { checkRolesChange, getRoles } from '@/api/login'
import { MessageBox } from 'element-ui';
export default {
  tryUpdateAuths: async function () {
    const user = store.state.login.userInfo
    const { schoolId, orgPermVersion, templatePermVersion } = user
    if (!schoolId) return
    const result = await checkRolesChange({ schoolId, templateVersion: templatePermVersion, orgVersion: orgPermVersion })
    if (result.body) {
      await getRoles(user)
      try {
        const result = await MessageBox.confirm('功能权限已更新，是否刷新页面', '提示')
        if (result === 'confirm') {
          location.reload()
        }
      } catch (error) { }
    }
  },
  // 检测角色权限（角色权限可能对于多个）
  checkAuthPerm: function (code, dict) {
    let perm = null
    if (Array.isArray(code)) {
      for (let index = 0; index < code.length; index++) {
        const element = code[index];
        perm = getAuthPerm(element, dict)
        if (perm != null) {
          return true
        }
      }
    } else {
      perm = getAuthPerm(code, dict)
    }
    return perm != null
  },
  getAuthPerm
}

function getAuthPerm (code, dict) {
  // console.log('\n开始检查', code)
  const user = store.state.login.userInfo
  const roles = user.roles
  if (!roles) return null
  if (dict) {
    for (let index = 0; index < roles.length; index++) {
      const role = roles[index];
      const perm = getPerm(role, code)
      if (perm && isGood(role, dict, 'gradeId') && isGood(role, dict, 'subjectCode') && isGood(role, dict, 'classId')) {
        // console.log('系统角色命中 - 年级、学科、班级')
        return perm
      }
    }
    // console.log('系统角色未命中')
    const dictPerm = getPerm(dict, code)
    // console.log('功能角色命中结果', dictPerm ? '成功' : '失败')
    return dictPerm
  } else {
    for (let index = 0; index < roles.length; index++) {
      const role = roles[index];
      const perm = getPerm(role, code)
      if (perm) {
        // console.log('系统角色命中 - code')
        return perm
      }
    }
  }
  return null
}

function isGood (role, dict = {}, key) {
  if (!role.dataPerms.some(item => item[key]) || role.dataPerms.some(item => item[key].length === 0)) {
    // console.log('系统权限信息命中“全部”', 'role.' + key + '=空')
    return true
  }
  if (!dict[key] || dict[key].length === 0) {
    // console.log('功能权限信息角色命中“全部”', 'dict.' + key + '=空')
    return true
  }
  // 兼容角色的多个班级、多个年级的情况
  const ids = role.dataPerms.map(item => item[key])
  for (let cIndex = 0; cIndex < dict[key].length; cIndex++) {
    const id = dict[key][cIndex];
    if (!id || ids.indexOf(id) >= 0) {
      // console.log('功能权限信息命中', 'dict.' + key + '=' + (id ? id : '空'))
      return true
    }
  }
  return false
}

function getPerm (obj, permCode) {
  return obj.perms.find(e => e.permCode === permCode)
}





// WEBPACK FOOTER //
// ./src/v2/utils/auth.js